



import React, { useRef, useState } from 'react';

import { BoxWrapper } from '../../../style';
import arrowIcon from "../../../images/arrow.png"
import { FormWrapper } from '../../../components/loan/style';
import Button from '../../../components/ui/Button';
import Alert from '../../../components/ui/Alert';

import { useNavigate } from 'react-router-dom';
import { goBack, isEmpty } from '../../../Utils/common';

import { formValidation } from '../../../Utils/formValidation';
import PictureUpload from '../../../components/PictureUpload/PictureUpload';
import { ButtonWrapper } from '../../../components/ui/style';
import photoCapturIcon from "../../../images/photo-capture.svg";
import Webcam from 'react-webcam';
import TakeImage from '../../../components/TakeImage/TakeImage';
import { ArrowLeft } from "lucide-react";


const initialData = {
  pinCode: "",
  city: "",
  state: "",
  landmark: "",
  address2: "",
  address1: "",
  residenceType: "",
}


function Ekyc() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({});
  const [responce, setResponce] = useState({});
  const [formData, setFormData] = useState(initialData);
  const [formDataError, setFormDataError] = useState(initialData);
  const [openCamera, setOpenCamera] = useState(false)
  const [aadharFront, setAadharFront] = useState("");
  const [aadharBack, setAadharBack] = useState("");

  const navigate = useNavigate();




  const submit = () => {


    const error = formValidation(formData);

    setFormDataError({ ...formDataError, ...error });
    const param = {

    }

    if (isEmpty(error)) {
      setLoading(true);
      //     verifyPan(param).then(resp=>{
      //     setLoading(false);
      //     console.log(resp?.data)
      //     if(resp?.data?.Status === 1){
      //       setResponce(resp?.data);
      //       setMessage({ type: 'success', msg:resp?.data?.Message, place:"globle" });
      //     }else{
      //       setMessage({ type: 'error', msg: resp?.data?.Message, });
      //     }


      // })

    }


  }




  return (
    <>

      <BoxWrapper className="w-full "  >


        <div className="formmainBox flex flex-col gap-6 ">
          <div>
            <div
              className="inline-flex items-center gap-2 px-5 py-2 border border-blue-500 rounded-lg cursor-pointer text-blue-600 font-medium hover:bg-blue-50 transition-all duration-300 group"
              onClick={() => goBack(navigate, "/my-dashboard/pan-upload")}
            >
              <ArrowLeft size={18} className='inline w-4 mr-1 text-blue-600 group-hover:-translate-x-1 transition-all duration-300' />
              <span>Back</span>
            </div>
          </div>

          <div className="right p-[20px] rounded-lg  " style={{ background: "#FFFFFF" }} >
            <h2 className=' text-3xl font-bold   text-[#1B2A57]' >Complate Your KYC</h2>
            <p>Upload you document and complete the kyc.</p>

            <FormWrapper>
              <Alert setMessage={setMessage} message={message} />

              <div className="inputBox">
                <div >
                  <h2 className='subheading small font-bold   text-[#1B2A57]'>Aadhar front side</h2>
                  <PictureUpload setImage={setAadharFront} image={aadharFront} />

                </div>
                <div>
                  <h2 className='subheading small font-bold   text-[#1B2A57]'>Aadhar back side</h2>
                  <PictureUpload setImage={setAadharBack} image={aadharBack} />

                </div>
              </div>



              <div className="button">
                <Button title="Continue" onClick={submit} loading={loading} />
              </div>
            </FormWrapper>

          </div>
        </div>

      </BoxWrapper>
    </>
  )
}

export default Ekyc;